























































import { defineComponent, Ref, ref } from '@vue/composition-api'

// components
import { Input } from '@/components/general'

// models
import { HistoryLoanControl } from '@/models/dailyControl'

// services
import LoanControlService from '@/services/dailyControl/LoanControlService'

// utils
import { success } from '@/utils/alerts'

export default defineComponent({
  name: 'TableHistoryLoanControl',
  components: { Input },
  props: {
    history: {
      type: Array,
      required: true
    }
  },
  setup () {
    const itemEdit: Ref<number|null> = ref(null)
    const updateRecord = async (item: HistoryLoanControl) => {
      console.log(item)
      itemEdit.value = item.id
      await LoanControlService.updateHistory(item.id, {
        loan_control_id: item.loan_control_id,
        fee: item.fee,
        date: item.date,
        amount: item.amount,
        status: item.status
      })
      success('Fecha Actualizada con Éxito.!')
      itemEdit.value = null
    }
    return { updateRecord, itemEdit }
  }
})
